// useGrammarWarm - load a grammar and report when the synchronous readers can
// use it.
//
// The code-mode unwrap runs inside a `useMemo` before the semantic feed is
// built, so it cannot await anything. Tree-sitter parsing is synchronous once
// a grammar is loaded, and only the load is not - so the loading is hoisted
// here and the memo simply re-runs when this flips.
//
// Three answers, settled once per session: "warming" while the load is in
// flight, "ready" when the grammar landed, "failed" when it settled without
// one. parserHost latches a failed load for the whole session (warmGrammar
// keeps resolving false), so "failed" is terminal - callers stop waiting and
// render their degraded reading instead of a pending region no load will
// ever finish.
import { useEffect, useState } from "react";
import { grammarReady, warmGrammar } from "./syntax/parserHost.js";

export function useGrammarWarm(language) {
  const [status, setStatus] = useState(() => (grammarReady(language) ? "ready" : "warming"));
  useEffect(() => {
    if (status !== "warming") return undefined;
    let live = true;
    warmGrammar(language).then((ok) => {
      if (live) setStatus(ok ? "ready" : "failed");
    });
    return () => { live = false; };
  }, [language, status]);
  return status;
}
